import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueLazyload from 'vue-lazyload'
import VueTheMask from 'vue-the-mask'

import router from './router/index.js'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './sass/base.scss'
import './sass/internal.scss'

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(BootstrapVue)
Vue.use(VueTheMask)
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDJuoIdZIPQGPN0nTwXfcWudnbkbh1iyDc"
    }
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'img/error.png',
  loading: 'img/loading.gif',
  attempt: 1
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
